import {
    Component,
    Input,
    OnInit,
    Output,
    ViewChild,
    EventEmitter,
    OnChanges, effect} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CoreConstants, HelperService, IdentifierService } from 'merlin-core';
import { UserProfileObject, UserService, ValidatorObj } from 'merlin-library';
import { BucketListComponent } from 'merlin-library';
import { ToastrService } from 'ngx-toastr';
import { ActionError } from 'projects/clinician/src/app/my-account/services/my-account.model';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { contactTypeCode } from '../../../enums/ContactTypeCode.enum';
import { EnrollPatientDeviceDataService } from '../../../services/enroll-patient-device-data.service';
import { PatientTransferRequestClinicService } from '../../../services/patient-transfer-request-clinic.service';
import * as _ from 'lodash-es';
@Component({
    selector: 'app-direct-call-messaging',
    templateUrl: './direct-call-messaging.component.html',
    styleUrls: ['./direct-call-messaging.component.scss'],
    standalone: false
})
export class DirectCallMessagingComponent implements OnInit, OnChanges {
    public directCallForm: UntypedFormGroup;
    public contactTypeCode = contactTypeCode;
    public selectedItem;

    public implantselectedItem;
    timeFormatFlag: boolean = false;
    medTeam: any;
    clinicans: any[];
    availablePhysList: any[] = [];
    assignedPhysList: any[] = [];
    errorMsgs = [];
    showMedicalSelOption: boolean;
    timeFormatvalue: String;

    isSP2Clinic: boolean;
    contactAlertList: any[];
    private originalCallContactTypeCd: any = null;

    msgReminderFlgValue: any = null;
    msgOverdueFlgValue: any = null;

    @ViewChild(BucketListComponent)
    bt: BucketListComponent;
    isOtherPhone: boolean = false;
    primaryMobile: boolean = false;
    isPrimaryMobile: boolean = false;
    isMarkImplantingActive = false;

    @Input() public messageForm: UntypedFormGroup;
    @Input() public dropDownsList;
    @Input() public countryCd;
    @Input() public isICMCategory = false;
    @Input() public isLPCategory = false;
    @Input() public avaliableIds = [];
    @Input() public assignedIds = [];
    @Input() public showPhysicianOpt = false;
    @Input() public showMarkImplantingButton = false;
    @Input() medicalOnCallSel;
    @Output() public callMethodChange: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() public markImplantPhyIdSel: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() public avaliableIdList: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() public assignedIdList: EventEmitter<any> =
        new EventEmitter<any>();

    @Input() functionMode: string;
    @Input() displayMode: string;
    @Input() patRes: any;
    @Output() public handleEmailPhone: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() public msgReminderFlgChange: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() public msgOverdueFlgChange: EventEmitter<any> =
        new EventEmitter<any>();

    public stringLabels = [
        "label.gb.direct_msgng",
        "label.gb.get_permission",
        "label.gb.auto_followup_reminders",
        "label.gb.auto_overdue_msg",
        "label.gb.between",
        "label.gb.am",
        "label.gb.and",
        "label.gb.pm",
        "label.gb.pm",
        "label.gb.std_rates_apply",
        "label.gb.other_phone",
        "label.gb.text_msg_info",
        "label.gb.std_rates_apply",
        "label.rpt.medical_team",
        "label.gb.place_med_team_after_hours_notif_order_blue",
        "label.gb.mark_implanting",
        "label.gb.am", 
        "label.gb.pm",
        "label.gb.drctcall_mthd"

    ]

    public labels: Record<string, string>;

    constructor(
        private localizationService: LocalizationService,
        public identifierService: IdentifierService,
        private route: ActivatedRoute,
        private requestService: PatientTransferRequestClinicService,
        private helperService: HelperService,
        private userService: UserService,
        private toasterService: ToastrService,
        private fb: UntypedFormBuilder,
        public deviceDataService: EnrollPatientDeviceDataService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
        this.userService
            .getUserProfile(false)
            .subscribe((userProfile: UserProfileObject) => {
                this.timeFormatvalue = userProfile.timeFormat;
                this.timeFormatFlag = userProfile.timeFormat === CoreConstants.defaultTimeFormat.toLowerCase();
            });
    }

    ngOnInit() {
        this.translateStrings();
        this.getUserData();
        this.messageForm
            .get('callContactTypeCd')
            .valueChanges.subscribe((change) => {
                // this.callMethodChange.emit(change);
            });

        this.medTeam = this.patRes?.medTeam;
        this.clinicans = this.patRes?.dropdowns?.clinicians;
        if (this.medTeam.implantPhyId != null) {
            this.implantselectedItem = this.medTeam.implantPhyId;
        } else {
            this.implantselectedItem = 999999;
        }
        // this.markImplantPhyIdSel.emit(this.implantselectedItem);
        this.mapPhysLists();
        this.bindFieldsData();
        this.updateCheckboxState();
        this.parseContactTypeCodeLabels();
        this.contactAlertList = this.getContactTypeCode();

        this.messageForm.get('msgOverdueFlg').valueChanges.subscribe(() => {
            this.contactAlertList = this.getContactTypeCode();
        });
        this.messageForm.get('msgReminderFlg').valueChanges.subscribe(() => {
            this.contactAlertList = this.getContactTypeCode();
        });
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    appendStringsToLabelList(listToAppend: string[]){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, listToAppend);
    }

    parseContactTypeCodeLabels(){
        let stringToAppend = []
        for(let code in this.contactTypeCode){
            stringToAppend.push(this.contactTypeCode[code]);
        }
        this.appendStringsToLabelList(stringToAppend);
    }


    bindFieldsData() {
        // this.route.params.subscribe((res) => {
        //     if (res?.id) {
        this.requestService.getPatientProfile().subscribe(
            (data) => {
                if (data?.messaging) {
                    this.originalCallContactTypeCd = data?.messaging?.callContactTypeCd;
                    this.messageForm
                        .get('callContactTypeCd')
                        .patchValue(data?.messaging?.callContactTypeCd);
                    this.callMethodChange.emit(
                        data?.messaging?.callContactTypeCd
                    );
                    this.messageForm
                        .get('msgEndAmpm')
                        .patchValue(data?.messaging?.msgEndAmpm);
                    this.messageForm
                        .get('msgEndTime')
                        .patchValue(data?.messaging?.msgEndTime);
                    if (this.patRes?.clinicDetails?.msgReminderFlg) {
                        this.messageForm
                            .get('msgReminderFlg')
                            .patchValue(data?.messaging?.msgReminderFlg);
                    } else {
                        this.messageForm
                            .get('msgReminderFlg')
                            .patchValue(false);
                    }
                    if (this.patRes?.clinicDetails?.msgOverdueFlg) {
                        this.messageForm
                            .get('msgOverdueFlg')
                            .patchValue(data?.messaging?.msgOverdueFlg);
                    } else {
                        this.messageForm
                            .get('msgOverdueFlg')
                            .patchValue(false);
                    }
                    this.messageForm
                        .get('msgStartAmpm')
                        .patchValue(data?.messaging?.msgStartAmpm);
                    this.messageForm
                        .get('msgStartTime')
                        .patchValue(data?.messaging?.msgStartTime);
                    if (data?.messaging?.patientCallSMS) {
                        if (this.messageForm.get('patientCallSMS')) {
                            this.messageForm
                            .get('patientCallSMS')
                            .patchValue(data?.messaging?.patientCallSMS);
                        }
                    }
                }
            },
            (err) => {
                if (err && err.actionErrors) {
                    this.showToaster(err.actionErrors);
                } else {
                    this.helperService.showErrorToastr(err);
                }
            }
        );
        //     }
        // });
    }

    mapPhysLists() {
        this.availablePhysList = [];
        this.assignedPhysList = [];
        if (this.medTeam?.assigned) {
            this.medTeam.assigned = _.sortBy(this.medTeam?.assigned, [
                function (o) {
                    return o.order;
                },
            ]);
            this.medTeam.assigned.forEach((element) => {
                let clinician = this.getClinician(element.id);
                if(clinician?.length > 0){
                    let clinicianToPush = clinician[0];
                    this.assignedPhysList.push(clinicianToPush);
                }
            });
        }
        if (this.medTeam?.availableIds) {
            this.medTeam.availableIds.forEach((element) => {
                // let clinicianToPush = this.getClinician(element)[0];
                // this.availablePhysList.push(clinicianToPush);

                let clinician = this.getClinician(element);
                if(clinician?.length > 0){
                    let clinicianToPush = clinician[0];
                    this.availablePhysList.push(clinicianToPush);
                }

            });
            this.availablePhysList = _.sortBy(this.availablePhysList, [
                function (o) {
                    return o.firstName.toLowerCase();
                },
            ]);
        }
    }

    getClinician(id: any) {
        return this.clinicans?.filter((clincian) => {
            return clincian.acctId == id;
        });
    }

    // ngAfterViewChecked() {
    //     this.markImplantingPhysician();
    // }
    ngAfterViewInit() {
        if (this.functionMode == 'enroll') {
            this.route.params.subscribe((res) => {
                if (res?.id) {
                    if (this.patRes?.messaging?.callContactTypeCd == 995) {
                        this.messageForm.addControl(
                            'patientCallSMS',
                            this.fb.control('')
                        );
                        this.showMedicalSelOption = true;
                    } else {
                        this.showMedicalSelOption = false;
                    }
                } else {
                    this.deviceDataService.showMedicalSelOption.subscribe(
                        (data) => {
                            this.showMedicalSelOption = data;
                            this.messageForm.addControl(
                                'patientCallSMS',
                                this.fb.control('')
                            );
                        }
                    );
                }
            });
            this.markImplantingPhysician();
            // For Profile Mode
        } else if (this.patRes?.messaging?.callContactTypeCd == 995) {
            this.messageForm.addControl('patientCallSMS', this.fb.control(''));
            this.showMedicalSelOption = true;
        } else if(this.patRes?.messaging?.callContactTypeCd ==994){
            this.primaryMobile = true;
        } else {
            this.showMedicalSelOption = false;
            this.primaryMobile = false;

        }
        this.disableDirectCallBox();
        this.disableDirectCallBoxReminder();
    }
    ngOnChanges() {
        const selectedValue = this.messageForm.get('callContactTypeCd').value;
        if (selectedValue == 993 || selectedValue == 994) {
            this.deviceDataService.primaryPhoneRequired.next(true);
        } else if((selectedValue == 995 || selectedValue == 1304) && this.countryCd === 140 && this.isICMCategory) {
            this.deviceDataService.primaryPhoneRequired.next(true);
        }
        else {
            this.deviceDataService.primaryPhoneRequired.next(false);
        }
    }

    onCallmedicalSelOption() {
        this.medicalOnCallSel = this.messageForm.get('callContactTypeCd').value;
        if (this.medicalOnCallSel === 995) {
            this.messageForm.addControl(
                'patientCallSMS',
                this.fb.control('', Validators.required)
            );
            this.isOtherPhone = true;
            this.showMedicalSelOption = true;
            if(this.countryCd === 140 && this.isICMCategory) {
                this.primaryMobile = true;
                // this.deviceDataService.showMedicalSelOption.next(true);
                this.deviceDataService.primaryPhoneRequired.next(true);
            } else {
            this.primaryMobile = false;
            // this.deviceDataService.showMedicalSelOption.next(true);
            this.deviceDataService.primaryPhoneRequired.next(false);
            }
            // selectedControl = controls[0];
        } else
         if (this.medicalOnCallSel == 993) {
            this.primaryMobile = true;
            this.showMedicalSelOption = false;
            //   this.handleEmailPhone.emit(true);
            this.deviceDataService.showMedicalSelOption.next(false);
            this.deviceDataService.primaryPhoneRequired.next(true);
            this.messageForm.removeControl('patientCallSMS');
        }else if(this.medicalOnCallSel == 994){
            this.primaryMobile = true;
            this.showMedicalSelOption = false;
            // this.deviceDataService.showMedicalSelOption.next(false);
            this.deviceDataService.primaryPhoneRequired.next(true);
            this.messageForm.removeControl('patientCallSMS');
        } else {
            this.showMedicalSelOption = false;
            // this.deviceDataService.showMedicalSelOption.next(false);
            this.deviceDataService.primaryPhoneRequired.next(true);

            this.messageForm?.get('patientCallSMS')?.clearValidators();
            this.messageForm?.get('patientCallSMS')?.updateValueAndValidity();
        }
        if (this.medicalOnCallSel == 1304) {
            this.messageForm.clearValidators();
            this.messageForm?.get('patientCallSMS')?.updateValueAndValidity();

            this.messageForm.removeControl('patientCallSMS');
            // this.deviceDataService.showMedicalSelOption.next(false);
            //   this.handleEmailPhone.emit(true);
            this.deviceDataService.primaryPhoneRequired.next(false);
            if(this.countryCd === 140 && this.isICMCategory) {
                this.primaryMobile = true;
                // this.deviceDataService.showMedicalSelOption.next(true);
                this.deviceDataService.primaryPhoneRequired.next(true);
            } else {
            this.primaryMobile = false;
            // this.deviceDataService.showMedicalSelOption.next(true);
            this.deviceDataService.primaryPhoneRequired.next(false);
            }
        }
    }

    // Marks Implanting Physician in merlin Bucket List
    markImplantingPhysician() {
        // Only update implantselectedItem if selectedItem is a valid DOM element
        if (this.selectedItem && typeof this.selectedItem.getAttribute === 'function') {
            const implantItem = this.selectedItem.getAttribute('value');

            if (!implantItem?.includes('label.gb.oncall_physician')) {
                // Extract ID from the selected element
                try {
                    const itemData = JSON.parse(implantItem);
                    if (itemData && itemData.acctId) {
                        this.implantselectedItem = itemData.acctId;
                        this.markImplantPhyIdSel.emit(this.selectedItem);
                    }
                } catch (e) {
                    // If parsing fails, keep the current value
                }
            }
        }

        let elements = document.querySelectorAll('.bucketlist-option');
        if (elements.length > 0 && this.selectedItem && typeof this.selectedItem.getAttribute === 'function') {
            const implantItem = this.selectedItem.getAttribute('value');
            if (!implantItem?.includes('label.gb.oncall_physician')) {
                elements.forEach((element) => {
                    if (element.getAttribute('value')) {
                        element.setAttribute('implanting', 'false');
                        if (
                            element
                                .getAttribute('value')
                                ?.includes(implantItem) &&
                            !implantItem?.includes('label.gb.oncall_physician')
                        ) {
                            element.setAttribute('implanting', 'true');
                            element.setAttribute('botSelected', 'false');
                        } else if (
                            implantItem?.includes('label.gb.oncall_physician')
                        ) {
                            this.selectedItem.setAttribute(
                                'botselected',
                                'false'
                            );
                            this.selectedItem = null;
                        }
                    }
                });
            } else {
                elements.forEach((element) => {
                    element.setAttribute('botselected', 'false');
                    this.selectedItem = null;
                });
            }
        }
    }

    rightSelectBoxUpdated_click(values) {}

    botSelectBoxUpdate(values) {
        this.messageForm.markAsDirty();
        this.assignedIdList.emit(values);
        // Reset selection state when list changes (item added/removed)
        this.selectedItem = null;
        document.querySelectorAll('.bot-option[botSelected="true"], .bot-option[botselected="true"]').forEach(
            el => el.setAttribute('botSelected', 'false')
        );
        this.isMarkImplantingActive = false;
    }

    botAvaliableIds(values) {
        this.avaliableIdList.emit(values);
    }

    onMarkImplanting(e) {}

    botSelectedItem(e) {
        this.selectedItem = e.currentTarget;
        this.updateMarkImplantingState();
    }

    updateMarkImplantingState() {
        const selectedElements = document.querySelectorAll('.bot-option[botSelected="true"], .bot-option[botselected="true"]');
        this.isMarkImplantingActive = selectedElements.length > 0;
    }

    // markImplatationPhyId() {
    //     this.implantselectedItem = this.selectedItem;
    //     this.implantselectedItem &&
    //         this.markImplantPhyIdSel.emit(this.implantselectedItem);
    //     let element = document.querySelector('[botselected="true"]');
    //     if (element == null) {
    //         return;
    //     }
    //     let data = JSON.parse(element.getAttribute('value'));
    //     element.setAttribute('botSelected', 'false');
    //     element.setAttribute('implanting', 'true');
    // }

    onMarkImplantingClick() {
        let element = document.querySelector('[botselected="true"]');
        if (element == null) {
            return;
        }
        let data = JSON.parse(element.getAttribute('value'));
        element.setAttribute('botSelected', 'false');
        // implanting physician id = data.acctId;
    }

    compareCodes(o1, o2) {
        return o1 == o2;
    }

    displayEditUI() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        } else {
            return false;
        }
    }

    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    disableDirectCallBox() {
        if (this.functionMode == 'enroll') {
             if(this.patRes?.clinicDetails?.msgOverdueFlg){
                this.messageForm
                        .get('msgOverdueFlg')
                        .enable();
             }
             return !this.patRes?.clinicDetails?.msgOverdueFlg;
         } else if (
             this.functionMode == 'profile' &&
             this.displayMode == 'edit'
         ) {
            // if(this.patRes?.clinicDetails?.msgOverdueFlg){
            //     this.messageForm
            //             .get('msgOverdueFlg')
            //             .enable();
            // } else {
            //     this.messageForm
            //             .get('msgOverdueFlg')
            //             .disable();
            // }
            return !this.patRes?.clinicDetails?.msgOverdueFlg
         } else {
             this.messageForm
                        .get('msgOverdueFlg')
                        .disable();
             return true;
         }
    }

    disableDirectCallBoxReminder(){
        if (this.functionMode == 'enroll') {
             if(this.patRes?.clinicDetails?.msgReminderFlg){
                this.messageForm
                        .get('msgReminderFlg')
                        .enable();
             }
             return !this.patRes?.clinicDetails?.msgReminderFlg;
         } else if (
             this.functionMode == 'profile' &&
             this.displayMode == 'edit'
         ) {
           if(this.patRes?.clinicDetails?.msgReminderFlg){
                this.messageForm
                        .get('msgReminderFlg')
                        .enable();
             }
             return !this.patRes?.clinicDetails?.msgReminderFlg
         } else {
             this.messageForm
                        .get('msgReminderFlg')
                        .disable();
             return true;
         }
    }

    getCallMethod() {
        let patChamb = this.patRes?.dropdowns?.contactTypeCodes.filter(
            (code) => {
                return code.codeId == this.patRes?.messaging?.callContactTypeCd;
            }
        );
        if (!patChamb) {
            return '';
        }
        if(patChamb?.length > 0){
        if (patChamb[0].code === 'SMSO') {
            this.isOtherPhone = true;
        }
        if (patChamb[0].code === 'SMSP') {
            this.isPrimaryMobile = true;
        }
        return this.translate('data.Code.Patient_Call_Contact_Type_Cd.Code_Desc.'+patChamb[0].code);
       }
       return '';
    }

    getContactTypeCode() {
        if (
            this.messageForm.controls.msgOverdueFlg.value ||
            this.messageForm.controls.msgReminderFlg.value
        ) {
            if (this.dropDownsList?.contactTypeCodes) {
                const updatedList = this.dropDownsList.contactTypeCodes.filter(
                    (item) => {
                        return item.codeId !== 1304;
                    }
                );
                const isNone = updatedList.filter((item) => {
                    return item.codeId === 1304;
                });
                !isNone?.length &&
                this.messageForm.get('callContactTypeCd').value == 1304
                    ? this.messageForm.get('callContactTypeCd').patchValue(993)
                    : '';
                this.defaultContactType();
                return updatedList;
            }
        }
        else {
            if (this.originalCallContactTypeCd != null) {
                this.messageForm.get('callContactTypeCd').patchValue(this.originalCallContactTypeCd, { emitEvent: false });
            }
            this.defaultContactType();
        }
        return this.dropDownsList?.contactTypeCodes;
    }

    defaultContactType(){
        let defaultContactType = this.messageForm.get('callContactTypeCd').value === 993;
        this.deviceDataService.setDefaultDirCallMethod(defaultContactType);
    }

    getUserData() {
        this.userService
            .getUserProfile(false)
            .subscribe((userData: UserProfileObject) => {
                this.isSP2Clinic =
                    userData.customerType === 'CL'
                        ? true
                        : userData?.customerType === 'SP2'
            });
    }

    getPhys(phys) {
        let patPhys = this.patRes?.dropdowns?.clinicians.filter((dev) => {
            return dev.acctId == phys;
        });
        if (!patPhys || patPhys?.length == 0) {
            return '';
        }

        const oncall_physician = "label.gb.oncall_physician";
        const lName = patPhys[0]?.lastName === oncall_physician ?
        this.translate(oncall_physician) : patPhys[0]?.lastName ? patPhys[0]?.lastName + ", " : '' ;
        const fName = patPhys[0]?.firstName ? patPhys[0]?.firstName + " ": '';
        const mName = patPhys[0]?.middleName ? patPhys[0]?.middleName + " " : '';
        const location = (patPhys[0]?.mainLocation && this.isSP2Clinic) ? patPhys[0]?.mainLocation + ': ' : '';

        return patPhys[0]?.credentialsCd ? location + lName + fName + mName + patPhys[0].credentialsCd : location + lName + fName + mName;
    }

    isViewImplanting(id: any) {
        return id == this.implantselectedItem;
    }

    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key);
    }

    showToaster(actionErrors: ActionError[]) {
        this.errorMsgs = [];
        actionErrors.forEach((item) => {
            const allKeys = Object.keys(item.parameters ?? {});
            let message = this.localizationService.generateLocalizedStr(
                item.message
            );
            allKeys.forEach((key) => {
                const param = item.parameters[key].message;
                message = message.replace(`{${key}}`, param);
            });

            this.errorMsgs.push(message);
            const errorMsg = this.helperService.getErrorList(this.errorMsgs);
            if (actionErrors.length == this.errorMsgs.length) {
                this.toasterService.error(errorMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
            }
        });
    }
    updateCheckboxState() {
        if (this.disableDirectCallBoxReminder()) {
            this.messageForm.get('msgReminderFlg')?.disable();
        }
        if (this.disableDirectCallBox()) {
            this.messageForm.get('msgOverdueFlg')?.disable();
        }
    }

    onCheckboxChangeMsgReminder(event: any) {
        if (event.checked) {
            this.msgReminderFlgValue = true;
        } else {
            this.msgReminderFlgValue = false;
        }
        this.msgReminderFlgChange.emit(this.msgReminderFlgValue);
    }


    onCheckboxChangeMsgOverdue(event: any) {
        if (event.checked) {
            this.msgOverdueFlgValue = true;
        } else {
            this.msgOverdueFlgValue = false;
        }
        this.msgOverdueFlgChange.emit(this.msgOverdueFlgValue);
    }
}
